<template>
  <div class="result">
    <div class="layout">
      <div v-if="result == 'SUCCESS' || result == 'PROCESSING'" class="sucPrompt">
        <img src="@/assets/images/template/success.png">
        <span>提交成功</span>
      </div>
      <div v-if="result == 'FAIL'" class="sucPrompt">
        <img src="@/assets/images/template/abnormal.png">
        <span>{{ msg }}</span>
      </div>
      <div class="orderList">
        <ul>
          <!-- <li>
            <p>订单号</p>
            <span>{{ pno }}</span>
          </li> -->
          <li>
            <p>转账账号</p>
            <span>{{ transferData.fromAccount.platformName }}</span>
          </li>
          <li>
            <p>收账账号</p>
            <span>{{ transferData.toAccount.platformName }}</span>
          </li>
          <li>
            <p>转账金额</p>
            <span>{{ transferData.amount }}美元</span>
          </li>
          <li>
            <p>转账时间</p>
            <span>{{ new Date(createDate).format("Y-MM-dd hh:mm:ss") }}</span>
          </li>
        </ul>
      </div>
      <div v-if="result == 'SUCCESS' || result == 'PROCESSING'" class="btn-container">
        <div class="btnItem">
          <span class="leftBtn" @click="goRecord">查看记录</span>
          <span
            class="rightBtn"
            @click="goTransfer"
          >继续转账</span>
        </div>
      </div>
    </div>
    <Chat />
    <ToHome />
  </div>
</template>

<script>
require('@/assets/css/result.css')
import Chat from '@/view/module/Chat.vue'
import ToHome from '@/view/module/ToHome.vue'
import { mapState } from 'vuex'

export default {
  name: 'PlatformTransferResult',
  components: { Chat, ToHome },
  computed: {
    ...mapState(['transferData', 'pageType'])
  },
  data() {
    return {
      result: this.$route.query.result || '',
      // pno: this.$route.query.pno || '',
      // fromAccount: JSON.parse(this.$route.query.fromAccount) || '',
      // toAccount: JSON.parse(this.$route.query.toAccount) || '',
      createDate: this.$route.query.createDate || '',
      // amount: this.$route.query.amount || '',
      msg: decodeURIComponent(this.$route.query.msg).replace(/\+/g, ' ') || ''

    }
  },
  methods: {
    goRecord() {
      this.$bus.$emit('loading', false)
      this.$store.dispatch('setTabIndex', 2)
      if (this.pageType == 'app') this.$router.replace({ path: '/home/record', query: { typeName: 'transfer' }})
      else this.$router.replace({ path: '/home/record' })
    },
    goTransfer() {
      this.$bus.$emit('loading', false)
      this.$router.replace({ path: '/home/platformTransfer', query: { toPlatform: this.transferData.toAccount.platform } })
    }
  }
}

</script>
